<div fxLayout="row" fxLayoutAlign="center center" style="position: absolute; top: 0; bottom: 0; left: 0; right: 0">
  <mat-progress-spinner mode="indeterminate" color="accent" diameter="72" strokeWidth="8" />
</div>
